var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,9.36A7.47,7.47,0,0,0,12,16.8c0,2,1.12,4.62,2.7,7.2a55.28,55.28,0,0,0,3.52,5,1.66,1.66,0,0,0,2.6,0,55.28,55.28,0,0,0,3.52-5c1.58-2.58,2.7-5.19,2.7-7.2A7.47,7.47,0,0,0,19.5,9.36Z",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,13.81a3.07,3.07,0,1,0,3.07,3.07A3.06,3.06,0,0,0,19.5,13.81Z",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7c6519268b47e108709b26eb237aecba.svg";
export { ForwardRef as ReactComponent };